import moment from "moment";
import { SENTIMENT_ACTION } from "./actions";
import { IData } from "../web/common";
import klineInterval from "../Params";

const DATA_COUNT = 50;
const COLLECTION_NAME = "NS_CRP_SIGNALS_30";

interface IXUData {
  signal30: { Basket: string[]; Outgoing: []; Incoming: []; Index: number };
  requested: boolean;
  loaded: boolean;
}

const initialState: IXUData = {
  signal30: {} as any,
  requested: false,
  loaded: false,
};

export function loadSignal30(firebase: any, period: number) {
  if (period < 0 || ![0, 10, 30, 99].includes(period)) {
    console.log("Invalid period for signal 30. Period:", period);
    return async function thunk(dispatch: any, getState: any) {
      dispatch({
        type: SENTIMENT_ACTION.EMPTY_ACTION,
        payload: {},
      });
    };
  }

  return async function thunk(dispatch: any, getState: any) {
    const state = getState();
    if (state.Signal30.requested) return;
    dispatch({
      type: SENTIMENT_ACTION.SIGNAL_30,
      payload: { requested: true, loaded: false, sentiment: [] },
    });
    let ix = 0;
    console.log(`${COLLECTION_NAME}${klineInterval}_P${period}`)
    firebase
      .firestore()
      .collection(`${COLLECTION_NAME}${klineInterval}_P${period}`)
      .where("reverse", "==", 0)
      .orderBy("dateTime", "desc")
      .limit(DATA_COUNT)
      .onSnapshot((querySnapshot: any) => {
        let signal30Data: Object[] = [];
        querySnapshot.forEach(function (doc: any) {

          signal30Data.push({
            key: ix++,
            name: "signal",
            Basket: doc.data().basket ?? [],
            Outgoing: doc.data().outgoing ?? [],
            Index: doc.data().index,
            Incoming: doc.data().incoming ?? [],
            Time: doc.data().time ?? 0,
            Date: moment(doc.data().dateTime.toDate())
              //.zone(0)
              .format("DD.MM.YY HH:mm"),
          });
        });

        dispatch({
          type: SENTIMENT_ACTION.SIGNAL_30,
          payload: {
            signal30: signal30Data,
            loaded: true,
            requested: true,
          },
        });
      });
  };
}

export default function Signal30(state = initialState, action: any) {
  switch (action.type) {
    case SENTIMENT_ACTION.SIGNAL_30:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
export const signal30Selector = (state: any) => state.Signal30;
